import React from "react";

const CustomTitle = ({
  title,
  margin,
}: {
  title: React.ReactNode;
  margin?: string;
}) => {
  return (
    <>
      <p className="text-3xl font-faune text-dark-blue">{title}</p>
      <hr className={`h-px bg-gray-500 border-0 ${margin ?? "mb-8"}`} />
    </>
  );
};

export default CustomTitle;
